import { render, staticRenderFns } from "./genelist.vue?vue&type=template&id=71ffd466&"
import script from "./genelist.vue?vue&type=script&lang=js&"
export * from "./genelist.vue?vue&type=script&lang=js&"
import style0 from "./genelist.vue?vue&type=style&index=0&id=71ffd466&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports